function reportTabToggle(event) {
  const titleEl = event.currentTarget.querySelector('.summary__title');
  let title = '';

  if (titleEl) {
    title = titleEl.innerText;
  }
  
  if (event.currentTarget.open) {
    Shopify.analytics.publish('details_tab_openned', { title: title });
  }
}

document.querySelectorAll('.product__accordion details').forEach(function (el) {
  el.addEventListener('toggle', reportTabToggle);
});

